import { useTranslation } from "react-i18next";
import { Button } from "reactstrap";
import { Window } from "@progress/kendo-react-dialogs";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import ParticipantService from "../../../services/srv-participants/ParticipantService";
import { FormInput } from "../../../components/sys-form/FormComponents";
import {
  emailValidator,
  requiredValidator,
} from "../../../components/sys-form/FormValidators";

export const ParticipantAdd = (props) => {
  const { t } = useTranslation();

  const onSubmit = (dataItem) => {
    const { isValid, values } = dataItem;
    if (!isValid) {
      return;
    }
    values.etkinliK_TANIM_ID = props.event.etkinliK_TANIM_ID;
    ParticipantService.addEventParticipant(values).then((data) => {
      props.toggleDialog();
      props.setIsAdded(true);
    });
  };

  return (
    <Window
      title={props.title}
      onClose={props.toggleDialog}
      stage={window.innerWidth < 1000 ? "FULLSCREEN" : "DEFAULT"}
      initialHeight={"60vh"}
      initialWidth={"30%"}
      style={{
        left: "50%",
        top: "50%",
        transform: "translate(-50%, -50%)",
        position: "fixed",
        zIndex: 10000,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {" "}
        <Form
          onSubmitClick={onSubmit}
          render={(formRenderProps) => (
            <div style={{ alignSelf: "center", width: "80%" }}>
              {" "}
              <FormElement>
                <Field
                  name="ad"
                  id="ad"
                  label={t("name")}
                  component={FormInput}
                  validator={(value) => requiredValidator(value, t)}
                />
                <Field
                  name="soyad"
                  id="soyad"
                  label={t("surname")}
                  component={FormInput}
                  validator={(value) => requiredValidator(value, t)}
                />
                <Field
                  name="email"
                  id="email"
                  label={t("email")}
                  component={FormInput}
                  validator={(value) => emailValidator(value, t)}
                />
                <div className="k-form-buttons">
                  <Button disabled={!formRenderProps.allowSubmit}>
                    {t("save")}
                  </Button>
                </div>
              </FormElement>
            </div>
          )}
        />
      </div>
    </Window>
  );
};
